import React from 'react';
import ColorfulIcon from './ColorfulIcon';
import { ctaFeatures } from '../mockData';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';

const iconGradients = ['blue', 'green', 'purple', 'orange'];

const CTA = () => {
  return (
    <section id="contact" className="py-6 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-blue-50 to-cyan-50 border border-gray-200 rounded-[3rem] p-12 md:p-16 text-center relative overflow-hidden">
          {/* Heading */}
          <h2 className="text-4xl md:text-6xl font-semibold text-gray-900 mb-6" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Display, sans-serif', letterSpacing: '-0.02em' }}>
            Transform Your IT
            <br />
            <span className="bg-gradient-to-r from-blue-600 to-cyan-500 text-transparent bg-clip-text">
              Infrastructure Today
            </span>
          </h2>

          {/* Description */}
          <p className="text-gray-600 text-lg max-w-3xl mx-auto mb-10" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Text, sans-serif' }}>
            Partner with R-Technos for end-to-end IT solutions tailored to your business needs.
            Our experts are ready to design, deploy, and support your entire IT ecosystem.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Link to="/contact">
              <Button size="lg" className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-base rounded-full shadow-md hover:shadow-lg transition-all">
                Get a Free Consultation
              </Button>
            </Link>
            <Link to="/products">
              <Button
                size="lg"
                variant="outline"
                className="border-2 border-blue-600 text-blue-600 hover:bg-white px-8 py-6 text-base rounded-full transition-all"
              >
                View All Services
              </Button>
            </Link>
          </div>

          {/* Features */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
            {ctaFeatures.map((feature, index) => {
              return (
                <div key={feature.id} className="flex flex-col items-center">
                  <ColorfulIcon 
                    icon={feature.icon} 
                    size={24} 
                    gradient={iconGradients[index % iconGradients.length]} 
                    className="mb-2"
                  />
                  <p className="text-gray-900 font-medium text-sm mt-2" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Text, sans-serif' }}>{feature.title}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;